import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "base/lang/en.json";
import translationKO from "base/lang/ko.json";

export const defaultNS = "translation";
// export const defaultNS = "common";
export const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
};
export type LanguageResource = keyof typeof resources;

i18n.use(initReactI18next).init({
  resources: resources,
  lng: process.env.NODE_ENV === "development" ? "en" : "ko",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
